import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeftRight } from "lucide-react";
import api from "../lib/api";
import { Spinner } from "./common";

/* Route network tab on airline profiles — top scheduled pairs from the routes dataset. */
export const AirlineRoutes = ({ airlineId, name }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/v1/airlines/${airlineId}/routes?limit=120`)
      .then((r) => setData(r.data.routes || []))
      .catch(() => setData([]));
  }, [airlineId]);

  if (!data) return <Spinner />;
  if (!data.length) {
    return <p className="text-sm text-zinc-500" data-testid="airline-routes-empty">No scheduled route data on file for {name}.</p>;
  }
  return (
    <div data-testid="airline-routes">
      <h2 className="font-heading font-900 text-lg md:text-xl text-zinc-900 mb-1 inline-flex items-center gap-2">
        <ArrowLeftRight className="w-5 h-5 text-sky-800" /> {name} route network
      </h2>
      <p className="text-sm text-zinc-500 mb-4">{data.length} scheduled city pairs — tap any pair for the full route page.</p>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
        {data.map((r) => (
          <Link key={r.route_key} to={`/route/${r.route_key}`} data-testid={`airline-route-${r.route_key}`}
            className="notranslate bg-white border border-zinc-200 px-3 py-2.5 text-sm font-mono font-700 text-zinc-800 text-center hover:border-sky-700 hover:text-sky-800 transition-colors">
            {r.route_key.replace("-", " ⇄ ")}
          </Link>
        ))}
      </div>
    </div>
  );
};
